module.exports = __webpack_public_path__ + "static/media/size_guide_banner_n.4acd7e1f.jpg";